<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  tabs: Array<{ id: string; label: string; content: any }>
  modelValue?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: ''
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const activeTab = ref(props.modelValue || props.tabs[0]?.id || '')

const selectTab = (tabId: string) => {
  activeTab.value = tabId
  emit('update:modelValue', tabId)
}
</script>

<template>
  <div>
    <TabButtons
      :tabs="tabs"
      :model-value="activeTab"
      @update:model-value="selectTab"
    />
    
    <div class="mt-4">
      <div
        v-for="tab in tabs"
        :key="tab.id"
        v-show="activeTab === tab.id"
      >
        <component :is="tab.content" />
      </div>
    </div>
  </div>
</template>
